import { RefObject } from 'react';


export const refParentNode = (refElement:RefObject<HTMLDivElement>) => {
  return refElement.current?.parentNode?.parentNode;
};
